import React, { useState } from 'react';
import { Formik, Form, getIn } from 'formik';
import InputMask from 'react-input-mask';
import ReactHtmlParser from 'react-html-parser';
import { TextField, Button, CircularProgress } from '@mui/material';
import { IUserInfo, IAnswer } from '../../api/entities';
import { trySendAnswers } from '../../api/requests/testing';
import { testingSchema } from '../../other/validationSchemas';
import { testQuestions } from '../../other/constants';

import './Test.css';

const initialValues: { userInfo: IUserInfo; answers: IAnswer[] } = {
  userInfo: {
    firstName: '',
    email: '',
    phoneNumber: '',
  },
  answers: testQuestions
    ? testQuestions.map((_, index) => ({
        questionNumber: index,
        answer: null,
      }))
    : [],
};

const TestScreen = () => {
  const [counter, setСounter] = useState(0);
  const [responseError, setResponseError] = useState('');
  const [isFinished, setIsFinished] = useState(false);

  const handleFormSubmit = async (data: { userInfo: IUserInfo, answers: IAnswer[] }) => {
    const result = await trySendAnswers(data);
    if (!result) {
      setResponseError('Сталася невідома помилка. Спробуйте знову пізніше.');
      return;
    }
    setResponseError('');
    setIsFinished(true);
  };

  const handleAnswerButtonClick = (
    formikSetFieldFunc: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
    answer: boolean,
    questionIndex: number,
  ) => {
    formikSetFieldFunc(`answers.${questionIndex}.answer`, answer);
    setСounter(counter + 1);
  }

  if (!testQuestions) {
    return (
      <div className="itemTest">
        <h1 className="textInfo">
          Вибачте, але запитань для проходження тесту поки що немає.
        </h1>
      </div>
    );
  }

  if (isFinished) {
    return (
      <div className="itemTest">
        <h1 className="textInfo">
          Дякуємо за ваші відповіді! Результати було відправлено на вказаний вами email.
        </h1>
      </div>
    );
  }

  return (
    <div className="container rounded containerTX">
      <Formik 
        initialValues={initialValues}
        onSubmit={handleFormSubmit}
        validationSchema={testingSchema}
      >
        {({ values, touched, errors, handleChange, isSubmitting, setFieldValue }) => (
          <Form>
            {testQuestions[counter] ? (
              <div className="row">
                  <div className="col-12 formTest"> 
                    <p className="fw-bold testCounter">{counter + 1} / {testQuestions.length}</p>
                    <p className="fw-bold testName">{ReactHtmlParser(testQuestions[counter])}</p>    
                    <div className="buttonForm">
                      <Button
                        variant="contained"
                        onClick={() => handleAnswerButtonClick(setFieldValue, true, counter)}
                      >
                        Так
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => handleAnswerButtonClick(setFieldValue, false, counter)}
                      >
                        Ні
                      </Button>
                    </div>
                  </div>
              </div> 
            ) : (
              <div className="col-12 textField">
                <p className="fw-bold testName">
                  Для того щоб отримати результати введіть ваші дані.
                </p>
                <div className="textt">
                  <div className="d-inline-block">
                    <div className="d-flex flex-column align-items-start">
                      <TextField
                        name="userInfo.firstName"
                        className="testTextField"
                        label="Ім'я"
                        type="text"
                        value={values.userInfo.firstName}
                        variant="filled"
                        error={getIn(errors, 'userInfo.firstName') && getIn(touched, 'userInfo.firstName')}
                        onChange={handleChange('userInfo.firstName')}
                      />
                      {errors.userInfo?.firstName && touched.userInfo?.firstName && (
                        <p className="fieldError mb-0 ms-2">{errors.userInfo.firstName}</p>
                      )}
                    </div>
                  </div>
                  <div className="d-inline-block">
                    <div className="d-flex flex-column align-items-start">
                      <TextField
                        name="userInfo.email"
                        className="testTextField"
                        label="E-mail"
                        value={values.userInfo.email}
                        type="email"
                        variant="filled"
                        error={getIn(errors, 'userInfo.email') && getIn(touched, 'userInfo.email')}
                        onChange={handleChange('userInfo.email')}
                      />
                      {errors.userInfo?.email && touched.userInfo?.email && (
                        <p className="fieldError mb-0 ms-2">{errors.userInfo.email}</p>
                      )}
                    </div>
                  </div>
                  <div className="d-inline-block">
                    <div className="d-flex flex-column align-items-start">
                      <InputMask
                        mask="+380 (99) 999 99 99"
                        value={values.userInfo.phoneNumber}
                        onChange={handleChange('userInfo.phoneNumber')}
                      >
                        {() => (
                          <TextField
                            name="userInfo.phoneNumber"
                            className="testTextField"
                            label="Номер телефону"
                            value={values.userInfo.phoneNumber}
                            type="tel"
                            variant="filled"
                            error={
                              getIn(errors, 'userInfo.phoneNumber') &&
                              getIn(touched, 'userInfo.phoneNumber')
                            }
                          />
                        )}
                      </InputMask>
                      {errors.userInfo?.phoneNumber && touched.userInfo?.phoneNumber && (
                        <p className="fieldError mb-0 ms-2">{errors.userInfo.phoneNumber}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 testName">
                {responseError && (
                  <p className="errorMessage mb-0">{responseError}</p>
                )}
                  <div className="d-flex justify-content-center buttonEnd">
                    <Button variant="contained" type="submit" disabled={isSubmitting}>
                      {isSubmitting && <CircularProgress size={25} />}
                      {!isSubmitting && 'Відправити'}
                    </Button>
                  </div>
                </div>
              </div>
            )}                
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TestScreen;
